import type { WallCard } from '@walls/store';

export interface BoardCardTree {
  rootCards: WallCard[];
  rootClusters: WallCard[];
}

export function isClusterCard(card: WallCard) {
  return Boolean(card.persistCluster || card.cards?.length);
}

export function getBoardCardTree(cards: WallCard[]): BoardCardTree {
  return cards.reduce<BoardCardTree>(
    (tree, card) => {
      if (isClusterCard(card)) {
        tree.rootClusters.push(card);
      } else {
        tree.rootCards.push(card);
      }

      return tree;
    },
    { rootCards: [], rootClusters: [] }
  );
}

export function sortByZPosition(cards: WallCard[]) {
  return [...cards].sort((a, b) => (a.zPos ?? 0) - (b.zPos ?? 0));
}

export function getClusterChildren(card: WallCard) {
  return (card.cards ?? []).reduce<BoardCardTree>(
    (tree, childCard) => {
      if (isClusterCard(childCard)) {
        tree.rootClusters.push(childCard);
      } else {
        tree.rootCards.push(childCard);
      }

      return tree;
    },
    { rootCards: [], rootClusters: [] }
  );
}
